import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";
import { Btn, Eyebrow, PageHero } from "@/components/site/bits";
import { Reveal } from "@/components/site/Reveal";
import { CONTACT, IMAGES } from "@/data/site";

const soon = () =>
    toast("Consultation scheduling is by phone or email for now — please use the contact details shown here.");

const cards = [
    { icon: Phone, label: "Phone", value: CONTACT.phone, id: "phone" },
    { icon: Mail, label: "Email", value: CONTACT.email, id: "email" },
    { icon: MapPin, label: "Location", value: CONTACT.location, id: "location" },
];

export default function Contact() {
    return (
        <main>
            <PageHero
                testid="contact-hero"
                eyebrow="Contact"
                title="You Don’t Have to Do This Alone."
                sub="Take the first step. Reach out today."
                image={IMAGES.cta}
            />
            <section className="bg-white">
                <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24">
                    <div className="grid gap-8 md:grid-cols-3">
                        {cards.map(({ icon: Icon, label, value, id }, i) => (
                            <Reveal key={id} delay={i * 0.08}>
                                <div data-testid={`contact-card-${id}`} className="h-full rounded-xl border border-[#0B1F3A]/10 bg-[#F9F8F3] p-8 text-center">
                                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#0B1F3A] text-[#D4AF37]">
                                        <Icon className="h-5 w-5" />
                                    </div>
                                    <p className="mt-4 text-xs font-bold uppercase tracking-[0.25em] text-[#C9A227]">{label}</p>
                                    <p className="mt-2 text-base font-semibold text-[#0B1F3A]">{value}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.15} className="mt-14">
                        <div className="rounded-2xl bg-[#0B1F3A] p-10 text-center sm:p-14">
                            <p className="font-script text-4xl text-white sm:text-5xl">Change Is Possible</p>
                            <p className="mx-auto mt-4 max-w-xl text-base text-white/80">
                                Education. Guidance. Support. A better tomorrow is possible — and it can start with a
                                single conversation.
                            </p>
                            <div className="mt-8 flex flex-wrap justify-center gap-4">
                                <Btn testid="contact-speak-btn" onClick={soon}>Speak with Dr. Jaquez</Btn>
                                <Btn variant="outlineLight" testid="contact-schedule-btn" arrow={false} onClick={soon}>
                                    Schedule a Consultation
                                </Btn>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>
        </main>
    );
}
